import { API_BASE } from '../config/api';

const handleResponse = async (response, fallbackMessage = 'Unable to load tournament admins.') => {
  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    const message = data.error || data.message || fallbackMessage;
    throw new Error(message);
  }

  return data;
};

export const createClubTournamentAdmin = async (payload, token) => {
  const response = await fetch(`${API_BASE}/api/clubs/tournament-admins`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });

  return handleResponse(response, 'Unable to create tournament admin.');
};

export const updateClubTournamentAdmin = async (adminId, payload, token) => {
  const response = await fetch(`${API_BASE}/api/clubs/tournament-admins/${adminId}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });

  return handleResponse(response, 'Unable to update tournament admin.');
};

export const deleteClubTournamentAdmin = async (adminId, token) => {
  const response = await fetch(`${API_BASE}/api/clubs/tournament-admins/${adminId}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return handleResponse(response, 'Unable to delete tournament admin.');
};

export const unassignClubTournamentAdminRole = async (clubId, userId, token) => {
  const response = await fetch(`${API_BASE}/api/clubs/${clubId}/roles/tournament-admin/${userId}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return handleResponse(response, 'Unable to remove tournament admin role.');
};

export const unassignClubDepartmentAdminRole = async (clubId, userId, token) => {
  const response = await fetch(`${API_BASE}/api/clubs/${clubId}/roles/department-admin/${userId}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return handleResponse(response, 'Unable to remove department admin role.');
};
